import { useFeatureFlagEnabled } from "posthog-js/react";

export const FEATURE_FLAGS = {
  FACEBOOK_LOGIN: "facebook-login",
} as const;

type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

export function useFeatureFlag(flag: FeatureFlagKey): boolean {
  return useFeatureFlagEnabled(flag) ?? false;
}
